import { RouteStageEnum } from "../../../../../../../enums/RouteStageEnum";

export function getStatusById(statusId) {
    for (const key in RouteStageEnum) {
        if (RouteStageEnum[key].id === statusId) {
            return RouteStageEnum[key].message;
        }
    }
}